import request from "../utils/requestV3";

/** 显式传入 null/undefined 时默认参数不会生效，统一收敛成普通对象。 */
function toSafeQueryParams(params) {
  if (params == null || typeof params !== 'object') {
    return {}
  }
  return params
}

function buildQueryString(params) {
  // 始终用收敛后的对象做 keys/取值，避免 filter/map 再碰可能为 null 的原始 params
  const safeParams = toSafeQueryParams(params)
  return Object.keys(safeParams)
    .filter((key) => {
      const value = safeParams[key]
      return value !== undefined && value !== null && value !== ''
    })
    .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(safeParams[key])}`)
    .join('&')
}

export function getAiAssistantList(params) {
    const queryString = buildQueryString(params);
    return request({
        url: `/aiAssistant/list?${queryString}`,
        method: "get"
    });
}


export function getAiAssistantById(params) {
    const queryString = buildQueryString(params);
    return request({
        url: `/aiAssistant/getWallpaperById?${queryString}`,
        method: "get"
    });
}


// 上下线接口
export function onOrOff(params) {
    return request({
        url: `/aiAssistant/onOrOff`,
        method: "post",
        data: params
    });
}

export function deleteAiAssistantById(params) {
    return request({
        url: `/aiAssistant/deleteResourceById`,
        method: "post",
        data: params
    });
}

export function addAiAssistant(params) {
    return request({
        url: `/aiAssistant/addResource`,
        method: "post",
        data: params,
        // 业务失败由创建页拼「新建失败：errMessage」，避免拦截器与页面双 toast
        resolveErrorDataOnBizError: true,
    });
}

export function updateAiAssistant(params) {
    return request({
        url: `/aiAssistant/updateResource`,
        method: "post",
        data: params,
        resolveErrorDataOnBizError: true,
    });
}


// 复制ai角色接口
export function copyAiAssistant(params) {
    return request({
        url: `/aiAssistant/copy`,
        method: "post",
        data: params
    });
}


// 批量上传ai角色接口
export function batchAddAiAssistant(params) {
    return request({
        url: `/aiAssistant/batchAdd`,
        method: "post",
        data: params
    });
}


// 批量删除
export function batchDeleteResource(params) {
    return request({
        url: `/aiAssistant/deleteResourceByIds`,
        method: "post",
        data: params,
    });
}